module.exports = __webpack_public_path__ + "img/thumbnail_CuviersDwarfCaiman_f_albino.7925c505.png";